import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import { SharedModule } from 'primeng/api';

/**
 * InputGroupAddon displays text, icon, buttons and other content can be grouped next to an input.
 * @group Components
 */
const _c0 = ["*"];
let InputGroupAddon = /*#__PURE__*/(() => {
  class InputGroupAddon {
    /**
     * Inline style of the element.
     * @group Props
     */
    style;
    /**
     * Class of the element.
     * @group Props
     */
    styleClass;
    static ɵfac = function InputGroupAddon_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InputGroupAddon)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: InputGroupAddon,
      selectors: [["p-inputGroupAddon"]],
      hostAttrs: [1, "p-element", "p-inputgroup-addon"],
      inputs: {
        style: "style",
        styleClass: "styleClass"
      },
      ngContentSelectors: _c0,
      decls: 2,
      vars: 3,
      consts: [[3, "ngClass", "ngStyle"]],
      template: function InputGroupAddon_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", ctx.styleClass)("ngStyle", ctx.style);
          i0.ɵɵattribute("data-pc-name", "inputgroupaddon");
        }
      },
      dependencies: [i1.NgClass, i1.NgStyle],
      encapsulation: 2
    });
  }
  return InputGroupAddon;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InputGroupAddonModule = /*#__PURE__*/(() => {
  class InputGroupAddonModule {
    static ɵfac = function InputGroupAddonModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || InputGroupAddonModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: InputGroupAddonModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, SharedModule]
    });
  }
  return InputGroupAddonModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { InputGroupAddon, InputGroupAddonModule };
